import { render, staticRenderFns } from "./StaplerBusAnimation.vue?vue&type=template&id=c8031f7e&scoped=true&"
import script from "./StaplerBusAnimation.vue?vue&type=script&lang=js&"
export * from "./StaplerBusAnimation.vue?vue&type=script&lang=js&"
import style0 from "./StaplerBusAnimation.vue?vue&type=style&index=0&id=c8031f7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8031f7e",
  null
  
)

export default component.exports